import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { PermissionLevels } from 'utils/permission'
import {
  Button,
  ButtonGroup
} from 'react-bootstrap'
import CardPicker from 'routes/Board/CardPicker'
import KanBoIcon from 'components/KanBoIcon'
import {
  ContentTitle,
  ContentIcon,
  ContentButton
} from 'components/Content'
import {
  ToggleModal
} from 'components/Modal'
import classes from './AddSubCard.module.scss'

export class AddSubCard extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,

    boardId: PropTypes.number.isRequired,
    statusId: PropTypes.number.isRequired,
    cardId: PropTypes.number.isRequired,
    subCardIds: PropTypes.array.isRequired,

    requestAddSubCard: PropTypes.func.isRequired,
    requestAddNewChildCard: PropTypes.func.isRequired
  }

  state = {
    addingSubCard: null,
    statusId: null,
    cardId: null,
    cardName: null,
    template: null,
  }

  hideAddSubCard = () => {
    this.toggleModalRef.close()
  }

  handleToggleModalRef = (ref) => {
    this.toggleModalRef = ref
  }

  handleModalShowToggle = (show) => {
    if (!show) {
      this.setState({
        addingSubCard: null,
        statusId: null,
        cardId: null,
        cardName: null
      })
    }
  }

  handleAddSubCardClick = () => {
    this.setState({
      addingSubCard: true,
      statusId: this.props.statusId,
      cardId: null,
      cardName: null
    })
  }

  cardFilter = ({ id }) => (id !== this.props.cardId && !this.props.subCardIds.includes(id))

  handleStatusChange = (statusId) => {
    this.setState({
      statusId
    })
  }

  handleCardChange = (cardId, cardName) => {
    this.setState({
      cardId,
      cardName
    })
  }

  handleTemplateChange = (template) => {
    this.setState({
      template,
    })
  }

  handleAddClick = () => {
    const {
      id,
      cardId: parentId,

      requestAddSubCard,
      requestAddNewChildCard
    } = this.props
    const {
      cardId,
      statusId,
      cardName,
      template,
    } = this.state

    if (cardId) {
      requestAddSubCard({
        cardId: parentId,
        subCardId: cardId,
        subCardGroupId: id
      })
    } else {
      requestAddNewChildCard({
        statusId,
        parentId,
        name: cardName,
        groupId: id,
        template: template !== 'empty' ? { type: 'card', id: +template } : 'empty',
      })
    }

    this.hideAddSubCard()
  }

  render () {
    const {
      boardId,
      statusId
    } = this.props
    const {
      addingSubCard,
      statusId: selectedStatusId,
      cardId,
      cardName
    } = this.state

    return (
      <ToggleModal
        backdrop
        ref={this.handleToggleModalRef}
        attachment='top center'
        targetAttachment='top center'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
        onToggle={this.handleModalShowToggle}
      >
        <ContentButton
          onClick={this.handleAddSubCardClick}
        >
          <ContentIcon>
            <KanBoIcon name='kanbo-16-plus' />
          </ContentIcon>
          <ContentTitle>
            <FormattedMessage id='SUBCARD_ADD' />
          </ContentTitle>
        </ContentButton>
        {addingSubCard && (
          <div className={classes.modal}>
            <CardPicker
              currentBoardId={boardId}
              currentStatusId={statusId}
              requiredPermissionLevel={PermissionLevels.MEMBER}
              isTemplate={false}
              cardFilter={this.cardFilter}
              onStatusChange={this.handleStatusChange}
              onCardChange={this.handleCardChange}
              onTemplateChange={this.handleTemplateChange}
            />
            <ButtonGroup className='m-b-10'>
              <Button
                bsStyle='primary'
                disabled={!selectedStatusId || (!cardId && !cardName)}
                onClick={this.handleAddClick}
              >
                <FormattedMessage id='ADD' />
              </Button>
              <Button
                onClick={this.hideAddSubCard}
              >
                <FormattedMessage id='CANCEL' />
              </Button>
            </ButtonGroup>
          </div>
        )}
      </ToggleModal>
    )
  }
}

export default AddSubCard
